import React from 'react';
import { CleaveInput } from '@cp-shared-19/frontend-ui';

type PostcodeInputProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
    inputId?: string;
};

export const PostcodeInput: React.FC<PostcodeInputProps> = ({ label, name, isMandatory = true, inputId }) => {
    return (
        <CleaveInput
            requiredText=" *"
            aria-required={isMandatory}
            className="c-form-field--no-floating"
            cleaveOptions={{
                delimiter: '',
                blocks: [5],
                numericOnly: true,
            }}
            inputMode={'numeric'}
            label={label}
            name={name}
            testId={`test-${name}`}
            inputId={inputId}
            required={isMandatory}
            isMandatory={isMandatory}
            autocomplete="postal-code"
        />
    );
};
